import React from 'react';
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  const navigate = useNavigate();
  const duckFacts = [
    "Ducks have better navigational skills than our routing system!",
    "Even ducks get lost sometimes, but they always find their way home.",
    "This duck tried to waddle to your page but took a wrong turn at the pond.",
    "Duck fact: They can see in color, unlike this 404 page.",
  ];
  
  const randomDuckFact = duckFacts[Math.floor(Math.random() * duckFacts.length)];

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-accent/5 to-accent/10 dark:from-accent/5 dark:to-accent/10" style={{ margin: 'calc(0px - (var(--spacing) * 4))' }}>
      <div className="text-center max-w-2xl mx-auto">
        <div className="w-64 h-48 mx-auto mb-8 flex items-center justify-center">
          <img 
            src="/assets/img/404.png" 
            alt="Plumber Duck" 
            className="h-full w-auto object-contain"
          />
        </div>
        
        <h1 className="text-6xl font-bold text-accent mb-4">404</h1>
        <h2 className="text-3xl font-semibold text-gray-800 dark:text-white mb-6">
          Quack! Looks like you're lost in the pond.
        </h2>
        
        <p className="text-lg text-gray-600 dark:text-gray-300 mb-8">
          {randomDuckFact} Don't worry, it's probably our fault. This page might have waddled away or never existed.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            onClick={() => navigate(-1)}
            variant="outline"
            className="gap-2 bg-white dark:bg-secondary"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </Button>
          <Button 
            onClick={() => navigate('/')}
            className="gap-2 bg-accent"
          >
            <Home className="w-4 h-4" />
            Return Home
          </Button>
        </div>
        
        {/* I liked this :( - @JShenton DED-296 */}
        {/* <p className="mt-8 text-sm text-gray-500 dark:text-gray-400">
          If you think this is a bug, please let us know. Our ducks will investigate!
        </p> */}
      </div>
    </div>
  );
}
